export enum TagProperty {
  id = '_id',
  tag = 'tag',
  active = 'active',
  imagesURL = 'imagesURL',

}
